import { useCallback } from 'react';
import { useManagePollVotesRealtime } from './useManagePollVotesRealtime';
import { useCursorPaginator } from '../../InfiniteScrollPaginator/hooks/useCursorPaginator';
import { usePollContext } from '../../../context';
import { useStateStore } from '../../../store';
const paginationStateSelector = (state) => [
    state.error,
    state.hasNextPage,
    state.loading,
];
export const usePollAnswerPagination = ({ paginationParams, } = {}) => {
    const { poll } = usePollContext();
    const paginationFn = useCallback(async (next) => {
        const { next: newNext, votes } = await poll.queryAnswers({
            filter: paginationParams?.filter,
            options: !next
                ? paginationParams?.options
                : { ...paginationParams?.options, next },
            sort: { created_at: -1, ...paginationParams?.sort },
        });
        return { items: votes, next: newNext };
    }, [paginationParams, poll]);
    const { cursorPaginatorState, loadMore } = useCursorPaginator(paginationFn, true);
    const answers = useManagePollVotesRealtime('answer', cursorPaginatorState);
    const [error, hasNextPage, loading] = useStateStore(cursorPaginatorState, paginationStateSelector);
    return {
        answers,
        error,
        hasNextPage,
        loading,
        loadMore,
    };
};
